module.exports = __webpack_public_path__ + "img/top.c4b7aa80.png";